export const goodsApi = {
    list: {
        method: 'post',
        api: 'admin/goods/list'
    },
    get: {
        method: 'post',
        api: 'admin/goods/get'
    },
    add: {
        method: 'post',
        api: 'admin/goods/add'
    },
    edit: {
        method: 'post',
        api: 'admin/goods/edit'
    },
    del: {
        method: 'post',
        api: 'admin/goods/del'
    },
    changeGoodStatus: {
        method: 'post',
        api: 'admin/goods/change_good_status'
    },
    get_cates_list: {
        method: 'post',
        api: 'admin/goods/get_cates_list'
    },
    del_cate: {
        method: 'post',
        api: 'admin/goods/del_cate'
    },
    add_cate: {
        method: 'post',
        api: 'admin/goods/add_cate'
    },
    edit_cate: {
        method: 'post',
        api: 'admin/goods/edit_cate'
    },
    examine: {
        method: 'post',
        api: 'admin/goods/examine'
    },
    get_remark_log: {
        method: 'post',
        api: 'admin/goods/get_remark_log'
    }
  }